// extracted by mini-css-extract-plugin
export default {"container":"Bw68ZwF","container__extraPadding":"cQnjWe9","hitArea":"DQztt72","chevronRight":"EL1yaG2","chevronLeft":"wefUUFp"};